import React from "react";
import { useFetch } from "lib/useFetch";
import ErrorBoundary from "lib/ErrorBoundary";
import { LoadingSpinner } from "lib/Spinner";
import { DataErrorMsg } from "pages/analystDirectory/AnalystDirectory";
import { FaqHeader } from "./FaqHeader";
import { FaqBody } from "./FaqBody";
import { i18n } from "app/i18n/i18n";

const FAQ_PREVIEW_URL = `/research/japi/content/preview/faq/`;

export const FaqPreview = ({ match }) => {
  const url = FAQ_PREVIEW_URL + match.params.id;
  const [faqItem, isLoading, isError] = useFetch(url, null, "GET");

  const lang = i18n.getLanguage();
  const faqItems = faqItem.id ? [faqItem] : [];
  const categories = [faqItem["category_" + lang]];

  return (
    <ErrorBoundary>
      <FaqHeader />
      {isLoading && <LoadingSpinner />}
      {isError && <DataErrorMsg />}
      {faqItems && faqItems.length && <FaqBody faq={faqItems} categories={categories} />}
    </ErrorBoundary>
  );
};
